var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Error\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,8.93933983 L13,5.93933983 L14.0606602,7 L11.0606602,10 L14.0606602,13 L13,14.0606602 L10,11.0606602 L7,14.0606602 L5.93933983,13 L8.93933983,10 L5.93933983,7 L7,5.93933983 L10,8.93933983 Z M18.5,6.1768759 L13.8231241,1.5 L6.1768759,1.5 L1.5,6.1768759 L1.5,13.412157 L6.21055497,18.4800107 L13.7905447,18.4967183 L18.5,13.412064 L18.5,6.1768759 Z M20,5.55555556 L20,14.0000004 L14.4444444,19.9981632 L5.55555556,19.9785707 L0,14.0016225 L0,5.55555556 L5.55555556,0 L14.4444444,0 L20,5.55555556 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.27323da394452a13f7a9e38370707322.svg";
export { ForwardRef as ReactComponent };